import { AnimatePresence, motion } from 'framer-motion'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { AiOutlineLogout } from 'react-icons/ai'
import { NavLink, useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { logout } from '@/api/login'
import LogoImg from '@/assets/images/1v1_logo_v2.png'
import UserAvatarImg from '@/assets/images/defaultUserAvatar.png'
import { centerStore, useRecoilValue, useSetRecoilState } from '@/store'

import ImgPlaceholder from '../ImgPlaceholder'
const { userState } = centerStore

const nav = [
  {
    title: '首页',
    link: '/',
    type: 1
  },
  {
    title: '师资介绍',
    link: '/v2/introductionOfTeachers',
    type: 1
  },
  {
    title: '课程体系',
    link: '/lesson',
    type: 1
  },
  {
    title: '下载中心',
    link: '/download',
    type: 1
  },
  {
    title: '帮助中心',
    link: '/web/help',
    type: 1
  },
  {
    title: '个人中心',
    link: '/center',
    type: 0
  }
]

const active = '个人中心'

export default function Index() {
  const [menuState, setMenuState] = useState(false)
  const user = useRecoilValue(userState)
  const navigate = useNavigate()

  const out = () => {
    logout({
      userId: user.id,
      // 设备唯一标识 - 指纹
      uniqueDeviceNo: localStorage.visitorId,
      // 1:一键登录 2:验证码登录 3:密码登录 4:微信登录 5：多孩子切换登录
      loginType: 3
    }).then((res) => {
      localStorage.clear()
      navigate('/login')
    })
  }

  return (
    <Container className="w-full h-[80px] bg-white m-0 p-0">
      <div className="h-full w-[1200px] ml-auto mr-auto flex justify-center items-center">
        <div className=" h-full flex justify-center items-center">
          <a className=" block h-[57px]" href="/">
            <ImgPlaceholder className=" h-full w-auto" src={LogoImg} alt="logo" />
          </a>
        </div>
        <div className=" flex-1">
          <ul className=" m-0 p-0 list-none flex items-center justify-center">
            {nav.map(({ title, link, type }) => (
              <li className={`nav w-[100px] h-[44px] ${active === title ? 'avtice' : ''}`} key={title}>
                {type === 0 ? (
                  <NavLink to={link} className="text-[#333333] w-full h-full flex items-center justify-center">
                    {title}
                  </NavLink>
                ) : (
                  <a className="text-[#333333] w-full h-full flex items-center justify-center" href={link}>
                    {title}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div className="h-full flex justify-center items-center relative cursor-pointer" onMouseLeave={() => setMenuState(false)} onMouseEnter={() => setMenuState(true)}>
          <div className="flex justify-center items-end flex-col mr-[10px]">
            <div>{user.username}</div>
            <div className={`h-[14px] w-[34px] text-[12px] text-white  rounded-full pl-[10px] pr-[10px] flex items-center justify-center ${user.isVip === '1' ? 'bg-red-500' : ''}`}>vip</div>
          </div>
          <div className="w-[38px] h-[38px] rounded-full">
            <ImgPlaceholder className="w-full h-full rounded-full" src={user.head} alt="UserAvatar" />
          </div>
          <AnimatePresence>
            {menuState ? (
              <Out initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} className="absolute flex justify-center items-center">
                <button onClick={out} className="flex justify-center items-center h-[30px] w-full text-[14px] hover:bg-[#eaeaea] bg-[#f2f2f2]">
                  <AiOutlineLogout className="mr-[4px]" />
                  退出登录
                </button>
              </Out>
            ) : null}
          </AnimatePresence>
        </div>
      </div>
    </Container>
  )
}

const Container = styled(motion.div)`
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  .nav {
    position: relative;
    a {
      transition: all 0.15s;
    }
    &:hover {
      a {
        color: #000;
        font-weight: bold;
      }
      ::before {
        content: '';
        position: absolute;
        left: 50%;
        bottom: 0;
        margin-left: -12px;
        width: 24px;
        height: 2px;
        background: #ff3300;
      }
    }
  }
  .avtice {
    a {
      color: #000;
      font-weight: bold;
    }
    ::before {
      content: '';
      position: absolute;
      left: 50%;
      bottom: 0;
      margin-left: -12px;
      width: 24px;
      height: 2px;
      background: #ff3300;
    }
  }
`
const Out = styled(motion.div)`
  width: 120px;
  background-color: #fff;
  box-shadow:
    rgb(60 64 67 / 30%) 0px 1px 2px 0px,
    rgb(60 64 67 / 15%) 0px 2px 6px 2px;
  border-radius: 4px;
  height: 40px;
  bottom: -30px;
  z-index: 1;
  /* right: 0; */
`
